export default "__VITE_ASSET__CcKBjK9L__"